var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStudyFlashcardOutline = function SvgStudyFlashcardOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "M6.666 20H5.333a2.667 2.667 0 0 1-2.667-2.667v-12a2.667 2.667 0 0 1 2.667-2.666h12a2.667 2.667 0 0 1 2.666 2.666v1.334M14.666 12h12a2.667 2.667 0 0 1 2.667 2.667v12a2.667 2.667 0 0 1-2.667 2.666h-12a2.667 2.667 0 0 1-2.667-2.666v-12A2.667 2.667 0 0 1 14.666 12"
  })));
};
export default SvgStudyFlashcardOutline;